import { useFetchCampaign } from '../../../hooks/useFetchCampaign';
import { useFetchShelfTiles } from '../../../hooks/useFetchShelfTiles';
import { useTileNavigation as useNavigation } from '../../../../campaignPreview/hooks/useTileNavigation';

export const useTileNavigation = ({ tile, campaignId }) => {
  // The fetches here are required to have the shelf and post tiles available
  // on page load when refreshing on the tile view page
  useFetchShelfTiles({});
  useFetchCampaign({ id: campaignId });

  return useNavigation({ tile, campaignId });
};
